import React from "react";
import { UpdateIBKRCredentialVariables } from "lib/api/mutations/graphql/UpdateIBKRCredential";
import { getLowTaxBrokerOrder_getLowTaxBrokerOrder_order } from "lib/api/queries/graphql/getLowTaxBrokerOrder";
import {
  RideButton,
  RideButtonSize,
  RideButtonVariant
} from "uiLibrary/designSystem/RideButton/RideButton";
import { RideTextInput } from "uiLibrary/components/RideTextInput/RideTextInput";
import { Form, FormikProvider, useFormik } from "formik";
import { Typography } from "uiLibrary/designSystem/Typography/Typography";

export interface UpdateIBKREmailProps {
  order: getLowTaxBrokerOrder_getLowTaxBrokerOrder_order;
  updateIBKRCredential: (variables: UpdateIBKRCredentialVariables) => void;
  isLoading: boolean;
}

const UpdateIBKREmail = ({ order, updateIBKRCredential, isLoading }: UpdateIBKREmailProps) => {
  const formik = useFormik({
    initialValues: {
      token: ""
    },
    onSubmit: (values) => {
      updateIBKRCredential({
        companyId: order.entityId ?? "",
        orderId: order.id,
        token: values.token ? values.token : undefined
      });
    }
  });

  if (!order.extra.isNewBrokerEnabled) {
    return null;
  }

  return (
    <FormikProvider value={formik}>
      <Form>
        <div className="update-ibkr-email">
          <Typography category={"Headline"} size={400} weight={"Heavy"}>
            Update user email in IBKR
          </Typography>
          <Typography category={"Paragraph"} size={100} weight={"Light"}>
            Steps:
            <ol>
              <li>Click on the "Update IBKR account email to user email" button.</li>
              <li>
                Enter the token the client received at their email address.{" "}
                <strong>This email may take some time to arrive.</strong>
              </li>
              <li>Click on the button again.</li>
              <li>
                Enter the second token the client received at their email address.{" "}
                <strong>This email may also take some time to arrive.</strong>
              </li>
              <li>Click on the button once more.</li>
              <li>
                Done!{" "}
                <span role="img" aria-label="celebration">
                  🥳
                </span>
              </li>
            </ol>
          </Typography>
          <div className="update-ibkr-email__controls">
            <RideTextInput
              name="token"
              label="Token for updating the email"
              placeholder="Enter token here"
            />
            <RideButton
              data-testid="update-ibkr-email-button"
              label="Update IBKR account email to user email"
              size={RideButtonSize.BIG}
              variant={RideButtonVariant.PRIMARY}
              type="submit"
              disabled={isLoading}
            />
          </div>
        </div>
      </Form>
    </FormikProvider>
  );
};

export default UpdateIBKREmail;
